export default __webpack_public_path__ + "c56d8702c9ec749ef75a926d1188f7ef.gif";